import { useMemo, useCallback } from "react";

export const hookGlobalMetaFieldsFactory = () => ({ fetch, siteSelected: { id: siteId } }) => {
  const parseParams = useCallback(({ attachedToSite = true, ...params }) => ({
    ...params, siteId, attachedToSite }
  ), [siteId])

  const getFields = useCallback(async (params = {}) => await fetch({
    url: `/meta-fields/all`,
    params: parseParams(params),
  }), [fetch, parseParams])

  return useMemo(() => ({
    metaFields: {
      getFields,
    },
  }), [getFields])
}
